import { createContext } from 'react'
import { portfolioStateInit } from './utils/reducers/PortfolioReducer'
import {featureFlagInit} from './utils/reducers/FeatureFlagReducer'
import { toastInitState } from './utils/reducers/ToastReducer'

export const PortfolioContext = createContext(portfolioStateInit)
export const FeatureFlagContext = createContext(featureFlagInit)
export const ToastContext = createContext(toastInitState)